import { PatchNotes } from "../../types/patches";

export const patch: PatchNotes = {
  id: "patch-5.0.11963",
  buildId: "5.0.11963",
  name: "Patch 11963",
  season: 0,
  type: "patch",
  officialUrl: "https://www.ageofempires.com/news/age-of-empires-iv-patch-11963/",
  summary: "",
  introduction: `
![](https://www.ageofempires.com/wp-content/uploads/2022/02/PatchNote_DEL_1920x1080-1080x608.jpg)
""`,
  date: new Date("2022-02-25T22:13:03Z"),
  sections: [

  ],
};
